import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { InvoiceInfoDto } from '@sr/dto';
import { useClientInvoices } from 'entities/client-invoices-list/lib/client-invoices-list.hook';
import { AddClientInvoiceDialog } from 'features/invoice/create-client-invoice/add-client-invoice-dialog';
import { FormData, formTools } from 'features/invoice/create-client-invoice/client-invoice.form-tools';
import { InvoicesList } from 'entities/invoice/list';
import { useState } from 'react';
import useConfirmDialog from 'hooks/confirm-dialog.hook';
import { useSnack } from 'shared/ui/snack';
import { useOurCompany } from 'hooks/portal-settings.hook';
import { useAddInvoice } from 'entities/invoice/invoice.hook';
import { useSearchParams } from 'react-router-dom';
import { usePagingParams } from 'shared/hooks/paging-params';

type Props = {
  companyId: number;
  isClientSupplier?: boolean;
};

export const CompanyClientInvoices = ({ companyId, isClientSupplier=false }: Props) => {
  const [ paging, setPaging ] = usePagingParams();
  const [ searchParams ] = useSearchParams();

  const { collection, changeCancelStatus } = useClientInvoices(paging, searchParams.toString(), companyId);
  const addInvoice = useAddInvoice({ companyId });
  const ourCompanyId = useOurCompany();

  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const { showError, showSuccess } = useSnack();
  const showConfirm = useConfirmDialog();

  const handleAddInvoice = async (data: FormData) => {

    const dto = formTools.toCreateDto(data);
    dto.buyerCompanyId = companyId;
    dto.sellerCompanyId = ourCompanyId;
    addInvoice(dto)
      .then(() => {
        showSuccess('Счет успешно добавлен');
        setAddDialogOpen(false);
        setPaging({ ...paging });
        collection?.reload?.();
      })
      .catch(e => showError(`Ошибка добавления счета: ${e.data.message}`));
  };

  const handleCancelInvoice = async (invoice: InvoiceInfoDto) =>
    showConfirm({ content: 'Отменить счет?' })
      .then(() => changeCancelStatus(invoice.id))
      .then(({ isCanceled }) => {
        showSuccess(`Счет ${isCanceled ? 'отменён' : 'восстановлен'}`);
        collection?.reload?.();
      })
      .catch(e => showError(`Ошибка отмены счета: ${e.message}`));

  return (
    <>
      <Button
        sx={{ mb: 2 }}
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setAddDialogOpen(true)}
      >
        Выставить счет
      </Button>

      <InvoicesList
        collection={collection}
        paging={paging}
        onChangePaging={setPaging}
        onCancel={handleCancelInvoice}
        withFilter
        invoiceFilterProps={{
          buyerLegalEntityFilter: {
            companyIdFilter: companyId,
            label: 'Клиентское юрлицо'
          },
        }}
      />

      <AddClientInvoiceDialog
        open={addDialogOpen}
        clientCompanyId={companyId}
        ourCompanyId={ourCompanyId}
        isClientSupplier={isClientSupplier}
        onClose={() => setAddDialogOpen(false)}
        onSubmit={handleAddInvoice} />
    </>);
};
